























































import Vue from 'vue';
import FormField from './FormField.vue';
import customerVuex from '../../../vuex/common';
import { newCustomFilter, CustomFilter } from '../../../models/CustomerFilter';
import CustomerProp, { PropType } from '../../../models/CustomerProp';
import CustomDate from './CustomDate.vue';
import CustomDateTime from './CustomDateTime.vue';
import CustomNumber from './CustomNumber.vue';
import CustomTextLike from './CustomTextLike.vue';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
    CustomDate,
    CustomDateTime,
    CustomTextLike,
    CustomNumber,
  },
  data() {
    return {
      hackId: 0,
      updated: false,
    };
  },
  computed: {
    customProps(): CustomerProp[] {
      return this.customerState.props.filter((prop) => {
        return !prop.builtIn || prop.fieldName === 'birth';
      });
    },
    filters(): any[] {
      return JSON.parse(JSON.stringify(this.customerFilter.custom));
    },
  },
  methods: {
    addCustom() {
      const filter = newCustomFilter();
      const v = this.customerFilter.custom;
      v.push(filter);
      this.updateCustomFilter(v);
      const el = this.$el;
      this.$nextTick(function() {
        const boxes = el.querySelectorAll('div.custom-filter-box');
        if (boxes && boxes.length) {
          boxes[boxes.length - 1].scrollIntoView({behavior: 'smooth' });
        }
      });
    },
    deleteCustom(key: number) {
      const v = this.customerFilter.custom;
      v.splice(key, 1);
      this.updateCustomFilter(v);
      this.hackId ++;
    },
    updateCustomFilter(filter: CustomFilter[]) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'custom',
        value: filter,
      });
    },
    updateField(key: number, fieldName: string) {
      const v = this.customerFilter.custom;
      const f = this.customProps.find((prop) => {
        return prop.fieldName === fieldName;
      });
      if (f) {
        v[key].prop = f;
      }
      this.updateCustomFilter(v);
    },
    updateGreater(key: number, greater: number) {
      const v = this.customerFilter.custom;
      v[key].greater = greater;
      if (v[key].notIn) {
        delete(v[key].notIn);
      }
      this.updateCustomFilter(v);
    },
    updateNum(key: number, num: number) {
      const v = this.customerFilter.custom;
      v[key].num = num;
      this.updateCustomFilter(v);
    },
    updateNums(key: number, nums: number[]) {
      const v = this.customerFilter.custom;
      v[key].nums = nums;
      this.updateCustomFilter(v);
    },
    updateKeywords(key: number, keywords: Array<string>) {
      const v = this.customerFilter.custom;
      v[key].keywords = keywords;
      this.updateCustomFilter(v);
    },
    updateDate(key: number, date: string) {
      const v = this.customerFilter.custom;
      v[key].date = date;
      this.updateCustomFilter(v);
    },
    updateNotIn(key: number, notIn: boolean) {
      const v = this.customerFilter.custom;
      v[key].notIn = notIn;
      if (v[key].greater) {
        delete(v[key].greater);
      }
      this.updateCustomFilter(v);
    },
    isDatePropType(prop: CustomerProp): boolean {
      return [PropType.LocalDate].includes(prop.propType);
    },
    isDateTimePropType(prop: CustomerProp): boolean {
      return [PropType.DateTime].includes(prop.propType);
    },
    isComparablePropType(prop: CustomerProp): boolean {
      return prop.propType === PropType.Numeric;
    },
  },
});
